import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

export const HeroSection = () => {
  return (
    <section
      className="relative min-h-[90vh] flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=2532&q=80)',
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 text-center">
        <h1
          className="font-headings text-6xl sm:text-7xl md:text-8xl lg:text-9xl text-white tracking-wider leading-none mb-6"
          data-testid="hero-title"
        >
          BORN WILD.
          <br />
          STAY WILD.
        </h1>
        <p
          className="font-subheadings text-xl md:text-2xl text-white/90 italic mb-10 max-w-2xl mx-auto"
          data-testid="hero-subtitle"
        >
          Premium southern-style apparel for hunters, fishers, and those who live free.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/shop">
            <Button
              className="bg-wild-leather text-white hover:bg-wild-leather/90 px-10 py-6 text-xl font-headings tracking-widest"
              data-testid="hero-shop-now-btn"
            >
              SHOP NOW
            </Button>
          </Link>
          <Link to="/shop">
            <Button
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-wild-dark px-10 py-6 text-xl font-headings tracking-widest bg-transparent"
              data-testid="hero-new-drops-btn"
            >
              NEW DROPS
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
